import useCore from 'modules/reports/hooks/core'
import React from 'react'
import useStyles from './ReportsShow.styles'
import {RouteComponentProps} from 'react-router'

type Params = {
  id?: string
}

type Props = {} & RouteComponentProps<Params>

function ReportsShowPage(props: Props) {
  const classes = useStyles()
  const {p, pt} = useCore('reports', 'pages', 'Show')

  return (
    <div className={classes.root} data-testid={p('title')}>
      {pt('title')}
    </div>
  )
}

export default ReportsShowPage
